import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'offers'
const verb = HttpMethod.DELETE

export default class OspreyOffersRemoveFromAffiliationsShare extends BaseAction {
    constructor(dataKey) {
        const id = '90b5b162-78c4-4b9c-ab31-b20ef4d3b653'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    removeFromAffiliationsShare(params) {
        const { offerId, affiliationIdList } = params

        this.path = `/${resource}/${offerId}/share/affiliations`

        this.params = {
            affiliationIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-affiliations-remove.js